import { LanguageService } from 'js/services/language.service';

export class LicLanguageService extends LanguageService {
    getPathLang = (lang) => {
        const pathLangAlias = this.getAliasForLanguage(lang);

        return pathLangAlias === lang ? this.getShortLanguage(lang) : pathLangAlias;
    };

    switzLangMapping = {
        'en-US': 'en-CH',
        'de-DE': 'de-CH',
        'it-IT': 'it-CH',
        'fr-FR': 'fr-CH'
    };
}

const languageService = new LicLanguageService();

export { languageService };
